module.exports = __webpack_public_path__ + "static/semantic-image-circular-258c95487ccd266a1412d4658ade9408.png";